import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';

import { APIsendConfirmationEmail } from '../api/Auth';

const EmailConfirmationForm: React.FC = () => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [success, setSuccess] = useState<boolean>(false);

  const { mutate, isPending, isError } = useMutation({
    mutationFn: async (data: { email: string }) => {
      return await APIsendConfirmationEmail(data.email);
    },
    onError: (error) => {
      setErrorMessage(error.message || 'An error occurred during signing up.');
    },
    onSuccess: () => {
      setErrorMessage(null);
      setSuccess(true);
    },
  });

  const schema = z.object({
    email: z.string({ message: "Email is required" }),
  });

  const { register, handleSubmit, formState: { errors } } = useForm<{ email: string }>({
    resolver: zodResolver(schema) as any,
  });

  const onSubmit = (data: { email: string }) => {
    mutate({ email: data.email });
  };

  return (
    <div className="container email-confirmation-form-container">
      <div className="email-confirmation-form">
        {isError && (
          <wa-callout variant="danger">
            <i className="fa-regular fa-circle-exclamation" slot="icon"></i>
            <strong>{errorMessage}</strong>
          </wa-callout>
        )}
        {success ? (
          <div className="wa-stack wa-gap-md">
            <wa-callout variant="success">
              <i className="fa-regular fa-circle-check" slot="icon"></i>
              <strong>Confirmation email sent!</strong>
            </wa-callout>
            <p className="center">Please check your email to verify your account.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit(onSubmit)} noValidate>
            <wa-input type="email" autofocus {...register('email')} className={errors.email ? 'invalid' : ''} hint={errors.email ? errors.email.message : ""} placeholder="Enter your email"></wa-input>
            <div className="center">
              <wa-button type="submit" disabled={isPending}>
                {isPending ? 'Wait...' : 'Send confirmation email again'}
              </wa-button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default EmailConfirmationForm;
